import React, { ReactNode } from 'react';

import { Alert, Button, Paper, Stack, Typography } from '@mui/material';

import Spinner from '~/components/Common/Spinner';

interface Props {
  title: string;
  description: string;
  buttonLabel: string;
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  errorMessage?: string;
  children?: ReactNode;
}

export default function PropertyActionCard({
  title,
  description,
  buttonLabel,
  onClick,
  isLoading = false,
  disabled = false,
  errorMessage,
  children,
}: Props) {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={2} alignItems="flex-start">
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
        <Button variant="contained" onClick={onClick} disabled={disabled || isLoading}>
          {isLoading ? <Spinner size={15} inline /> : buttonLabel}
        </Button>
        {errorMessage && (
          <Alert severity="error" sx={{ width: '100%' }}>
            {errorMessage}
          </Alert>
        )}
        {children}
      </Stack>
    </Paper>
  );
}
